// 2 定义路由
// 每个路由应该映射一个组件。 其中"component" 可以是
// 通过 Vue.extend() 创建的组件构造器，
// 或者，只是一个组件配置对象。
// 我们晚点再讨论嵌套路由。
const namespace = "";

export default [
	{
		path: "/",
		redirect: "/train",
	},
	{
		path: "/train",
		name: "train",
		meta: {
			activeNav: "train",
			title: "首页",
			tracker: {
				pad: "aw621",
			},
		},
		// 1 定义（路由）组件。
		// 异步组件, 有另一种代码分块的语法，使用 AMD 风格的 require，用来设置 code-split point
		component: resolve => require(["./train"], resolve),
		children: [],
	},
	{
		path: "/train/detail",
		name: "train/detail",
		meta: {
			activeNav: "train",
			title: "任务详情页",
			tracker: {
				pad: "aw622",
			},
		},
		component: resolve => require(["./train/detail"], resolve),
		children: [],
	},
	{
		path: "/train/selectTrainStu",
		name: "train/selectTrainSt",
		meta: {
			activeNav: "train",
			title: "所有课程选择报名人员",
			tracker: {
				pad: "aw605",
			},
		},
		// 1 定义（路由）组件。
		// 异步组件, 有另一种代码分块的语法，使用 AMD 风格的 require，用来设置 code-split point
		component: resolve => require(["./train/selectTrainStu"], resolve),
		children: [],
	},
	{
		path: "/train/settleAccounts",
		name: "train/settleAccounts",
		meta: {
			activeNav: "allcourse",
			title: "所有课程结算",
			tracker: {
				pad: "aw606",
			},
		},
		// 1 定义（路由）组件。
		// 异步组件, 有另一种代码分块的语法，使用 AMD 风格的 require，用来设置 code-split point
		component: resolve => require(["./train/settleAccounts"], resolve),
		children: [],
	},
	{
		path: "/train/special",
		name: "train/special",
		meta: {
			activeNav: "allcourse",
			title: "全部专题列表",
			tracker: {
				pad: "aw630",
			},
		},
		// 1 定义（路由）组件。
		// 异步组件, 有另一种代码分块的语法，使用 AMD 风格的 require，用来设置 code-split point
		component: resolve => require(["./train/special"], resolve),
		children: [],
	},
	{
		path: "/train/specialDetail",
		name: "train/specialDetail",
		meta: {
			activeNav: "allcourse",
			title: "专题详情",
			tracker: {
				pad: "aw629",
			},
		},
		// 1 定义（路由）组件。
		// 异步组件, 有另一种代码分块的语法，使用 AMD 风格的 require，用来设置 code-split point
		component: resolve => require(["./train/specialDetail"], resolve),
		children: [],
	},
	{
		path: "/courselink",
		name: "courselink",
		meta: {
			activeNav: "courselink",
			title: "语文招生",
			tracker: {
				pad: "aw621",
			},
		},
		// 1 定义（路由）组件。
		// 异步组件, 有另一种代码分块的语法，使用 AMD 风格的 require，用来设置 code-split point
		component: resolve => require(["./courseLink"], resolve),
		children: [],
	},
	{
		path: "/readingcourse",
		name: "readingcourse",
		meta: {
			activeNav: "readingcourse",
			title: "阅读加油站",
			// tracker: {
			// 	pad: "AXXWEB_69",
			// },
		},
		component: resolve => require(["./courseLink/readingCourse"], resolve),
		children: [],
	},
	{
		path: "/allcourse",
		name: "allcourse",
		meta: {
			activeNav: "allcourse",
			title: "全部课程",
			tracker: {
				pad: "aw620",
			},
		},
		// 1 定义（路由）组件。
		// 异步组件, 有另一种代码分块的语法，使用 AMD 风格的 require，用来设置 code-split point
		component: resolve => require(["./allcourse"], resolve),
		children: [],
	},
	{
		path: "/allcourse/detail",
		name: "allcourse/detail",
		meta: {
			activeNav: "allcourse",
			title: "全部课程-详情",
			tracker: {
				pad: "aw604",
			},
		},
		// 1 定义（路由）组件。
		// 异步组件, 有另一种代码分块的语法，使用 AMD 风格的 require，用来设置 code-split point
		component: resolve => require(["./allcourse/detail"], resolve),
		children: [],
	},
	{
		path: "/allcourse/selectTrainStu",
		name: "allcourse/selectTrainSt",
		meta: {
			activeNav: "allcourse",
			title: "所有课程选择报名人员",
			tracker: {
				pad: "aw605",
			},
		},
		// 1 定义（路由）组件。
		// 异步组件, 有另一种代码分块的语法，使用 AMD 风格的 require，用来设置 code-split point
		component: resolve => require(["./allcourse/selectTrainStu"], resolve),
		children: [],
	},
	{
		path: "/allcourse/settleAccounts",
		name: "allcourse/settleAccounts",
		meta: {
			activeNav: "allcourse",
			title: "所有课程结算",
			tracker: {
				pad: "aw606",
			},
		},
		// 1 定义（路由）组件。
		// 异步组件, 有另一种代码分块的语法，使用 AMD 风格的 require，用来设置 code-split point
		component: resolve => require(["./allcourse/settleAccounts"], resolve),
		children: [],
	},
	{
		path: "/allcourse/selectadmin/:courseId",
		name: "allcourse/selectadmin",
		meta: {
			activeNav: "allcourse",
			title: "所有课程选择申请人",
		},
		component: resolve => require(["./allcourse/selectAdmin"], resolve),
	},
	{
		path: "/traincenter",
		name: "traincenter",
		meta: {
			activeNav: "traincenter",
			title: "我的培训",
		},
		component: resolve => require(["./traincenter"], resolve),
		children: [
			{
				path: "mycourses",
				name: "mycourses",
				meta: {
					activeNav: "mycourses",
					title: "我的报名",
					tracker: {
						pad: "aw637",
					},
				},
				component: resolve => require(["./traincenter/mycourses"], resolve),
			},
			{
				path: "trainingData",
				name: "trainingData",
				meta: {
					activeNav: "trainingData",
					title: "参训数据",
					tracker: {
						pad: "aw639",
					},
				},
				component: resolve => require(["./trainingData"], resolve),
			},
			{
				path: "myapplication",
				name: "myapplication",
				meta: {
					activeNav: "myapplication",
					title: "申请列表",
					tracker: {
						pad: "aw641",
					},
				},
				component: resolve => require(["./traincenter/myapplication"], resolve),
			},
		],
	},
	{
		path: "/forum-center",
		name: "forum-center",
		meta: {
			activeNav: "forum-center",
			title: "我的留言",
		},
		component: resolve => require(["./forumCenter"], resolve),
		children: [
			{
				path: "reply-to-me",
				name: "reply-to-me",
				meta: {
					activeNav: "reply-to-me",
					title: "回复我的",
					tracker: {
						pad: "aw642",
					},
				},
				component: resolve => require(["./forumCenter/replyToMe"], resolve),
			},
			{
				path: "reply-from-me",
				name: "reply-from-me",
				meta: {
					activeNav: "reply-from-me",
					title: "我的留言",
					tracker: {
						pad: "aw643",
					},
				},
				component: resolve => require(["./forumCenter/replyFromMe"], resolve),
			},
		]
	},
	{
		path: "/train/giftpack",
		name: "train/giftpack",
		meta: {
			activeNav: "train",
			title: "大礼包",
			tracker: {
				pad: "aw628",
			},
		},
		component: resolve => require(["./giftpack"], resolve),
	},
	{
		path: "/train/doubleteacher",
		name: "train/doubleteacher",
		meta: {
			activeNav: "train",
			title: "双师尊享服务权益",
			tracker: {
				pad: "aw635",
			},
		},
		component: resolve => require(["./double-teacher"], resolve),
	},
	{
		path: "/trainingData/detail/:courseId",
		name: "trainingData/detail",
		meta: {
			activeNav: "trainingData",
			title: "参训数据",
			tracker: {
				pad: "aw640",
			},
		},
		component: resolve => require(["./trainingData/trainingDetail"], resolve),
	},
	{
		path: "/trainingReport/:courseId",
		name: "trainingReport",
		meta: {
			activeNav: "trainingReport",
			title: "参训报告",
			tracker: {
				pad: "aw638",
			},
		},
		component: resolve => require(["./trainingReport"], resolve),
	},
];
